var _path, _g, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1020,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 600.027h1019.972V-.048H0z",
    fill: "#003893"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 453.36h1020.918v-51.04H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 425.999h1021.297V300.23H0z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 402.295h1021.389v-51.04H-.001z",
    fill: "#cf2027"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#f7d116",
    transform: "matrix(1.33333 0 0 -1.33333 -409.399 401.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m487.011-.701 4.764-14.636h15.426l-12.477-9.05 4.767-14.639-12.48 9.047-12.482-9.047 4.769 14.639-12.48 9.05h15.423m3.492 91.24L490.5 61.27h15.426l-12.48-9.045 4.767-14.636-12.48 9.045-12.48-9.045 4.767 14.636-12.477 9.045h15.423m222.873 14.585 4.767-14.604h15.426l-12.48-9.029 4.767-14.604-12.48 9.026-12.48-9.026 4.767 14.604-12.48 9.029h15.423M702.413-.742l4.767-14.607h15.429l-12.48-9.029 4.767-14.607-12.482 9.026-12.477-9.026 4.764 14.607-12.477 9.029h15.423"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m594.818-75.184 4.764-14.671h15.426l-12.477-9.066 4.767-14.671-12.48 9.066-12.482-9.066 4.769 14.671-12.48 9.066h15.423"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: -67.424,
    y: -21.877
  }), /*#__PURE__*/React.createElement("path", {
    d: "m662.105-53.358 4.764-14.671h15.429l-12.48-9.066 4.769-14.673-12.482 9.066-12.48-9.066 4.767 14.673-12.48 9.066h15.423m-127.64 12.933 4.767-14.671h15.426l-12.48-9.066 4.767-14.673-12.48 9.069-12.48-9.069 4.767 14.673-12.48 9.066h15.426M660.152 134.48l4.767-14.671h15.426l-12.477-9.066 4.767-14.671-12.482 9.066-12.48-9.066 4.767 14.671-12.477 9.066h15.423"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m594.762 154.675 4.767-14.671h15.429l-12.482-9.066 4.769-14.671-12.482 9.066-12.48-9.066 4.767 14.671-12.477 9.066h15.421"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCv);
export default __webpack_public_path__ + "static/media/cv.78738abed16f8158565f497a96692138.svg";
export { ForwardRef as ReactComponent };